import React, { useEffect, useState, useCallback } from 'react';
import AdminSidebar from './AdminSidebar';
import AdminTopbar from './AdminTopbar';
import './AdminLayout.css';

const SIDEBAR_COLLAPSED_KEY = 'admin.sidebar.collapsed';
const LARGE_BREAKPOINT = 1024;

const isLargeScreen = () =>
    typeof window !== 'undefined' && window.innerWidth >= LARGE_BREAKPOINT;

const AdminLayout = ({
    selectedSection,
    onSelectSection,
    theme,
    onToggleTheme,
    pendingSuggestions = 0,
    onOpenSuggestions,
    children,
}) => {
    const [collapsed, setCollapsed] = useState(() => {
        if (typeof window === 'undefined') return false;
        const saved = localStorage.getItem(SIDEBAR_COLLAPSED_KEY);
        if (saved !== null) return saved === 'true';
        return !isLargeScreen();
    });
    const [mobileOpen, setMobileOpen] = useState(false);

    useEffect(() => {
        try {
            localStorage.setItem(SIDEBAR_COLLAPSED_KEY, String(collapsed));
        } catch (_) { /* ignore */ }
    }, [collapsed]);

    useEffect(() => {
        const handleResize = () => {
            if (isLargeScreen()) setMobileOpen(false);
        };
        window.addEventListener('resize', handleResize);
        return () => window.removeEventListener('resize', handleResize);
    }, []);

    const handleToggleCollapsed = useCallback(() => setCollapsed((prev) => !prev), []);
    const handleToggleMobileSidebar = useCallback(() => setMobileOpen((prev) => !prev), []);
    const handleCloseMobile = useCallback(() => setMobileOpen(false), []);

    const handleSelectSection = useCallback(
        (key) => {
            onSelectSection(key);
            setMobileOpen(false);
        },
        [onSelectSection]
    );

    return (
        <div className={`admin-shell ${collapsed ? 'admin-shell--collapsed' : ''} ${mobileOpen ? 'admin-shell--mobile-open' : ''}`}>
            <div className="admin-shell__sidebar-wrapper">
                <AdminSidebar
                    selectedSection={selectedSection}
                    onSelectSection={handleSelectSection}
                    collapsed={collapsed}
                    onToggleCollapsed={handleToggleCollapsed}
                    badges={{ sugerencias: pendingSuggestions }}
                />
            </div>

            {mobileOpen && (
                <div
                    className="admin-shell__backdrop"
                    onClick={handleCloseMobile}
                    aria-hidden="true"
                />
            )}

            <div className="admin-shell__main">
                <AdminTopbar
                    selectedSection={selectedSection}
                    onToggleMobileSidebar={handleToggleMobileSidebar}
                    theme={theme}
                    onToggleTheme={onToggleTheme}
                    pendingSuggestions={pendingSuggestions}
                    onOpenSuggestions={onOpenSuggestions}
                />
                <main className="admin-shell__content">
                    <div className="admin-shell__content-inner">{children}</div>
                </main>
            </div>
        </div>
    );
};

export default AdminLayout;
